import {DateTime} from "luxon";
import {FPNetDate} from "@commons/types";

export interface ValidDtRange {
    validitaInizio: FPNetDate,
    validitaFine: FPNetDate,
}

export class DateTimeUtils {
    static isBetween = (range: ValidDtRange, dtRiferimento: DateTime = DateTime.now()) => {
        const validitaInizio = (range.validitaInizio ? DateTime.fromISO(range.validitaInizio) : DateTime.now()).startOf('day');
        const validitaFine = (range.validitaFine ? DateTime.fromISO(range.validitaFine) : DateTime.now()).startOf('day');

        return validitaInizio <= dtRiferimento.startOf('day') && dtRiferimento.startOf('day') <= validitaFine;
    }


    /**
     * La durata massima dell'intervallo temporale di una richiesta di WF è stata fissata a 2 mesi,
     * o meglio: la data di fine massima è pari alla fine del mese successivo a quello di partenza
     * @param dtInizio
     */
    static getMaxDtGiornoFine = (dtInizio: string) => {
        const dtFine = DateTime.fromISO(dtInizio).endOf('month').plus({months: 1}).endOf('month').toISODate();
        return dtFine ? dtFine : ''; // isDateBetween esegue controllo se stringa vuota
    }
}